import { TemplateComposition } from '../../../client/templates/templates';
import { getTemplateAPIVersion } from '../../utils/version';

export function pickBestComposition(
  compositions: TemplateComposition[]
): TemplateComposition | undefined {
  if (compositions.length < 1) {
    return undefined;
  }
  const supportedVersion = parseInt(getTemplateAPIVersion());
  const index = compositions
    .map((c, index) => ({ version: parseInt(c.minTemplateAPIVersion), index }))
    .filter((c) => c.version <= supportedVersion)
    .reduce((prev, current) => (current.version > prev.version ? current : prev), {
      version: 0,
      index: -1,
    }).index;
  if (index >= 0) {
    return compositions[index];
  }
  return undefined;
}
